module.exports = __webpack_public_path__ + "static/media/0012.272afd4.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/0012.mp3
// module id = DV8Y
// module chunks = 0